import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import Enllac from 'components/3catinfo/Enllac';
import Icona from 'components/3catinfo/ui/Icona';
import Image from 'next/image';
import { dataResources } from 'utils/constants';
import MenuLogin from '../MenuLogin';
import Dropdown from '../Dropdown';
import AppsFlyerBanner from 'components/3catinfo/AppsFlyerBanner';
import styles from './mainmenu.module.scss';
import { useViewport } from 'hooks/3catinfo/useViewport';
import __isEmpty from 'lodash/isEmpty';
import { getItemsMenu } from '../funcions';
import { useScript } from 'hooks/useScript';
import { peuSideMenu } from '../../../corporatiu/MenuSecundari/contentMenu.jsx';

const { basePath } = dataResources;

const imageLoader = ({ src }) => {
    return `${src}`;
};

const ContentMenu = ({
    tipus,
    seccio,
    temesDestacats,
    informatius,
    podcasts,
    temesGenerics,
    destacatsPortal,
    isSideMenuOpen,
    setIsSideMenuOpen
}) => {
    const items = getItemsMenu({ tipus, seccio, temesDestacats, informatius, podcasts, temesGenerics, destacatsPortal });
    const [dropdownOpened, setDropdownOpened] = useState(null);
    const { isMobile, zoomNavigator } = useViewport();
    const { isJavaScriptClientEnabled } = useScript();
    const accessibilityRefs = {
        closeMenu: useRef(null),
        openMenu: useRef(null)
    };
    const menuPrincipalRef = useRef();

    const TRESCATINFOW = '/_resources/logos/3catinfo_W.svg?v=JIT_ENV_RESOURCES_VERSION';

    const handleDropdownToggle = (id) => {
        setDropdownOpened((prev) => (prev === id ? null : id));
    };

    const stylesContentMenu = clsx({
        [styles.contentMenu]: true,
        [styles.isOpen]: isSideMenuOpen === 'opened',
        [styles.ambZoom]: zoomNavigator > 1.25,
        [styles.scrollMenu]: zoomNavigator >= 2 && !isMobile
    });

    const stylesBgContentMenu = clsx({
        [styles.bgContentMenu]: isSideMenuOpen === 'opened',
        [styles.isOpen]: isSideMenuOpen === 'opened'
    });

    useEffect(() => {
        if (isSideMenuOpen === 'opened') {
            document.body.style.overflow = 'hidden';
            accessibilityRefs.closeMenu.current?.focus();
        } else if (isSideMenuOpen === 'closed') {
            document.body.style.overflow = 'auto';
            accessibilityRefs.openMenu.current?.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSideMenuOpen]);

    const _buildElement = (item, i) => {
        const { id, type, text, slug, icona, icona_alt, opcions, href } = item;

        if (__isEmpty(opcions)) {
            const stylesLink = clsx({
                [styles.itemLink]: true,
                [styles.active]: slug !== undefined && slug === seccio
            });
            if (slug === '#') return <></>;

            return (
                <div
                    key={`menu-item-${i}`}
                    onClick={(e) => {
                        setIsSideMenuOpen('closing');
                        setTimeout(() => {
                            setIsSideMenuOpen('closed'); // Se ejecuta después de 500ms
                        }, 500);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            setIsSideMenuOpen('closing');
                            setTimeout(() => {
                                setIsSideMenuOpen('closed'); // Se ejecuta después de 500ms
                            }, 500);
                        }
                    }}
                    role='listitem'
                >
                    <Enllac
                        className={stylesLink}
                        type={type}
                        id={id}
                        slug={slug}
                        href={href}
                        tabIndex='0'
                        dataTestId={`link-${slug}`}
                    >
                        {!__isEmpty(icona) && (
                            <Icona
                                className={styles.iconaMenu}
                                icona={icona}
                                alt={icona_alt}
                                mida='16'
                                inline={true}
                                ariaHidden={true}
                            />
                        )}
                        <span>{!__isEmpty(text) && text}</span>
                    </Enllac>
                </div>
            );
        } else {
            return (
                <div key={`menu-item-${i}`} role='listitem'>
                    <Dropdown
                        item={item}
                        dropdownOpened={dropdownOpened}
                        setDropdownOpened={handleDropdownToggle}
                        seccio={seccio}
                        isMobile={isMobile}
                        isMenuSticky={false}
                        setIsSideMenuOpen={setIsSideMenuOpen}
                        isSideMenuOpen={isSideMenuOpen}
                    />
                </div>
            );
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            handleCloseSideMenu();
        }
        if (e.key === 'Tab') {
            // Controla que el focus no surti del dropdown amb el Tab
            handleFocus(e);
        }
    };

    const handleCloseSideMenu = () => {
        if (isSideMenuOpen === 'opened') {
            const focusableElem = Array.from(menuPrincipalRef.current.querySelectorAll('button[aria-expanded="true"]'));
            if (focusableElem.length === 0) {
                setIsSideMenuOpen('closing');
                setTimeout(() => {
                    setIsSideMenuOpen('closed'); // Se ejecuta después de 500ms
                }, 500);
            }
        }
    };

    const handleFocus = (event) => {
        if (isSideMenuOpen === 'opened') {
            const focusableElem = Array.from(
                menuPrincipalRef.current.querySelectorAll("a, button, [tabindex]:not([tabindex='-1'])")
            );

            const firstFocusableElem = focusableElem[0];
            const lastFocusableElem = focusableElem[focusableElem.length - 1];
            const isTabPressed = event.key === 'Tab';

            if (!isTabPressed) {
                return;
            }

            if (event.shiftKey) {
                if (document.activeElement === firstFocusableElem) {
                    lastFocusableElem.focus();
                    event.preventDefault();
                }
            } else if (document.activeElement === lastFocusableElem) {
                firstFocusableElem.focus();
                event.preventDefault();
            }
        }
    };

    useEffect(() => {
        if (isSideMenuOpen === 'opened') {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSideMenuOpen]);

    return (
        <>
            {isMobile && (
                <div className={styles.barraMobile} id='barra-mobile'>
                    <div className={styles.logo}>
                        <button
                            data-testid='boto-obre-menu'
                            ref={accessibilityRefs.openMenu}
                            className={styles.ico_menu}
                            onClick={(e) => {
                                setIsSideMenuOpen('opened');
                            }}
                            aria-expanded={isSideMenuOpen === 'opened'}
                            aria-controls='mainMenu'
                        >
                            <Icona icona='menu' alt='Menú' isBlanc={false} mida={24} />
                        </button>
                        <Enllac href='/3catinfo/'>
                            <div className={styles.logo3catinfo}>
                                <Image
                                    loader={imageLoader}
                                    unoptimized={true}
                                    priority={true}
                                    width={119}
                                    height={24}
                                    alt='Logo 3CatInfo'
                                    src={basePath + TRESCATINFOW}
                                />
                            </div>
                        </Enllac>
                    </div>
                </div>
            )}

            <nav aria-label='Menú principal' className={stylesBgContentMenu} id='mainMenu' data-opened='true'>
                <div className={stylesContentMenu} data-opened-menu='true' ref={menuPrincipalRef}>
                    <div>
                        {isMobile && (
                            <button
                                ref={accessibilityRefs.closeMenu}
                                className={styles.ico_tanca}
                                onClick={(e) => {
                                    setIsSideMenuOpen('closing');
                                    setTimeout(() => {
                                        setIsSideMenuOpen('closed'); // Se ejecuta después de 500ms
                                    }, 500);
                                }}
                                aria-controls='mainMenu'
                            >
                                <Icona icona='tanca' alt='Tanca' ariaHidden={true} />
                                <span className='sr-only'>Tanca menú de navegació</span>
                            </button>
                        )}

                        <div className={styles.menuItems}>
                            <div className={styles.menuItemsItem} role='list'>
                                {!__isEmpty(items) &&
                                    Array.from(items.item)
                                        .slice(0, 5)
                                        .map((element, i) => _buildElement(element, i))}
                            </div>
                            <div className={styles.menuItemsItem} role='list'>
                                {!__isEmpty(items) &&
                                    Array.from(items.item)
                                        .slice(5)
                                        .map((element, i) => _buildElement(element, i))}
                            </div>
                        </div>
                    </div>
                    {isMobile && <>{peuSideMenu()}</>}
                </div>
            </nav>
        </>
    );
};

const MenuDesktop = ({
    tipus = 'estatic',
    seccio,
    temesDestacats,
    informatius,
    podcasts,
    temesGenerics,
    destacatsPortal,
    estil,
    tema,
    titol,
    isSideMenuOpen,
    setIsSideMenuOpen
}) => {
    const stylesMenu = clsx({
        [styles.menu]: true,
        [styles.menuDesktop]: true,
        [styles[estil]]: !__isEmpty(estil),
        [styles[tema]]: !__isEmpty(tema),
        [styles.mobilReduit]: !__isEmpty(titol)
    });

    useEffect(() => {
        if (isSideMenuOpen === 'opened') {
            document.body.style.overflow = 'hidden';
        } else if (isSideMenuOpen === 'closing') {
            document.body.style.overflow = 'auto';
        }
    }, [isSideMenuOpen]);

    return (
        <>
            <div className={stylesMenu} data-testid='menu'></div>

            <ContentMenu
                tipus={tipus}
                seccio={seccio}
                temesDestacats={temesDestacats}
                informatius={informatius}
                podcasts={podcasts}
                temesGenerics={temesGenerics}
                destacatsPortal={destacatsPortal}
                tema={tema}
                titol={titol}
                estil={estil}
                isSideMenuOpen={isSideMenuOpen}
                setIsSideMenuOpen={setIsSideMenuOpen}
            />
        </>
    );
};

const MenuCorporate = (props) => {
    const { requiredServices, seccio } = props;
    const { basePath } = dataResources;
    const { isMobile } = useViewport();

    const TRESCATINFOW = '/_resources/logos/3catinfo_W.svg?v=JIT_ENV_RESOURCES_VERSION';

    const logoinfoClass = clsx(styles.logoinfo, {
        [styles.noBefore]: isMobile === undefined // Si no está inicializado, desactiva el estilo :before
    });

    const stylesCorporate = clsx({
        [styles.corporate]: true
    });

    return (
        <nav aria-label='Menú corporatiu' className={stylesCorporate} id='navegacio'>
            <div className={styles.wrapper}>
                <div className={styles.logo} id='navLogo'>
                    <Enllac href='/3cat/'>
                        <div className={styles.logo3cat}>
                            <Image
                                loader={imageLoader}
                                loading='eager'
                                unoptimized={true}
                                width={111}
                                height={32}
                                alt='Logo 3Cat'
                                src={basePath + '/_resources/logos/3cat_color.svg?v=JIT_ENV_RESOURCES_VERSION'}
                            />
                        </div>
                    </Enllac>
                </div>
                <ul className={styles.marques} id='navMarques'>
                    <li>
                        <Enllac href='https://www.3cat.cat/tv3/' className={`${styles.logoLink} ${styles.logoRebaixat}`}>
                            <div className={styles.logotv3}>
                                <Image
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={32}
                                    height={24}
                                    alt='TV3'
                                    src={basePath + '/_resources/logos/tv3_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                />
                            </div>
                        </Enllac>
                    </li>
                    <li>
                        <Enllac href='https://www.3cat.cat/catradio/' className={`${styles.logoLink} ${styles.logoRebaixat}`}>
                            <div className={styles.logocr}>
                                <Image
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={32}
                                    height={24}
                                    alt='Catalunya Ràdio'
                                    src={basePath + '/_resources/logos/cr_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                />
                            </div>
                        </Enllac>
                    </li>
                    <li>
                        <Enllac href='/3catinfo/' className={styles.logoLink}>
                            {seccio === 'home' ? (
                                <h1 className={logoinfoClass}>
                                    <span className='sr-only'>3CatInfo, el portal informatiu de 3Cat</span>
                                    <Image
                                        loader={imageLoader}
                                        loading='eager'
                                        unoptimized={true}
                                        width={129}
                                        height={26}
                                        alt='3catinfo'
                                        src={basePath + TRESCATINFOW}
                                    />
                                </h1>
                            ) : (
                                <div className={logoinfoClass}>
                                    <Image
                                        loader={imageLoader}
                                        loading='eager'
                                        unoptimized={true}
                                        width={129}
                                        height={26}
                                        alt='3catinfo'
                                        src={basePath + TRESCATINFOW}
                                    />
                                </div>
                            )}
                        </Enllac>
                    </li>
                    <li>
                        <Enllac href='https://www.3cat.cat/tv3/sx3/' className={`${styles.logoLink} ${styles.logoRebaixat}`}>
                            <div className={styles.logosx3}>
                                <Image
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={40.74}
                                    height={20}
                                    alt='SX3'
                                    src={basePath + '/_resources/logos/sx3_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                />
                            </div>
                        </Enllac>
                    </li>
                    <li>
                        <Enllac href='/3cat/eva/' className={`${styles.logoLink} ${styles.logoRebaixat}`}>
                            <div className={styles.logoeva}>
                                <Image
                                    src={basePath + '/_resources/logos/eva_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={40.87}
                                    height={18}
                                    alt='EVA'
                                ></Image>
                            </div>
                        </Enllac>
                    </li>
                </ul>
                {isMobile ? (
                    <div className={`${styles.secundari} ${styles.iconesLink} ${styles.iconesUser} ${styles.logoRebaixat}`}>
                        <MenuLogin requiredServices={requiredServices} className={styles.login} />
                    </div>
                ) : (
                    <ul className={styles.secundari}>
                        <li>
                            <div className={styles.corpo} id='navCorpo'>
                                <Enllac href='/corporatiu/ca/el-grup/' className={styles.logoRebaixat}>
                                    Corporatiu
                                </Enllac>
                            </div>
                        </li>
                        <li>
                            <div className={styles.icones} id='navBotiga'>
                                <Enllac
                                    href='https://botiga.3cat.cat/'
                                    title='accedeix a la botiga de 3Cat'
                                    className={`${styles.iconesLink} ${styles.logoRebaixat}`}
                                >
                                    <Image
                                        loader={imageLoader}
                                        loading='eager'
                                        unoptimized={true}
                                        width={22}
                                        height={22}
                                        alt='botiga'
                                        src={
                                            basePath +
                                            '/_resources/icones/noticies/blanc/ic_botiga.svg?v=JIT_ENV_RESOURCES_VERSION'
                                        }
                                    />
                                </Enllac>
                            </div>
                        </li>
                        <li>
                            <div id='navCerca'>
                                <Enllac
                                    href='/cercador/?profile=portalunic'
                                    title='accedeix a la pàgina de cerca'
                                    className={`${styles.iconesLink} ${styles.logoRebaixat}`}
                                >
                                    <Image
                                        loader={imageLoader}
                                        loading='eager'
                                        unoptimized={true}
                                        width={24}
                                        height={24}
                                        alt='cercador'
                                        src={
                                            basePath +
                                            '/_resources/icones/noticies/blanc/cercador.svg?v=JIT_ENV_RESOURCES_VERSION'
                                        }
                                    />
                                </Enllac>
                            </div>
                        </li>
                        <li>
                            <div className={`${styles.iconesLink} ${styles.iconesUser} ${styles.logoRebaixat}`}>
                                <MenuLogin requiredServices={requiredServices} className={styles.login} />
                            </div>
                        </li>
                    </ul>
                )}
            </div>
        </nav>
    );
};

const MainMenu = ({
    requiredServices,
    isSideMenuOpen,
    setIsSideMenuOpen,
    seccio,
    tipus,
    temesDestacats,
    informatius,
    podcasts,
    temesGenerics,
    destacatsPortal,
    mostraAppsFlyerBanner = true
}) => {
    return (
        <>
            {mostraAppsFlyerBanner && <AppsFlyerBanner />}

            <MenuCorporate
                requiredServices={requiredServices}
                isSideMenuOpen={isSideMenuOpen}
                seccio={seccio}
                setIsSideMenuOpen={setIsSideMenuOpen}
            />
            <MenuDesktop
                tipus={tipus}
                seccio={seccio}
                temesDestacats={temesDestacats}
                informatius={informatius}
                podcasts={podcasts}
                temesGenerics={temesGenerics}
                destacatsPortal={destacatsPortal}
                isSideMenuOpen={isSideMenuOpen}
                setIsSideMenuOpen={setIsSideMenuOpen}
            />
        </>
    );
};

export default MainMenu;
